<template>
    <div class="lang-tabs" :class="langErrors[inputKey] ? 'el-form-item is-error' : 'el-form-item lang-tabs'">
        <label class="block"> {{inputName}} </label>
        <ul>
            <li 
                v-for="(value, key, index) in languages" 
                v-bind:key="key"
                :class="{'is-active' : isActiveTab(index)}"    
            >
                <a @click="active = index">{{value}}</a>
            </li> 
        </ul>
        
        <div>
            <div
                v-for="(value, key, index) in languages"
                v-if="isActiveTab(index)"
            >

                <el-input @input="langData" @change="langData" v-model="input[key]" />
                <small v-if="langErrors[inputKey]" style="padding-bottom: 20px; color: red"> {{ langErrors[inputKey][0] }} </small>
            </div>
        </div>
    </div>
</template>

<script>
    import InputField from '../Inputs/InputField'
    import model from '@/model/index'

    export default {
        name: 'LangTabs',
        components: {
            'input-field': InputField
        },
        props: ['langErrors', 'inputKey', 'inputName', 'inputValue'],
        data () {
            return {
                active: 0,
                input: {
                    en: '',
                    bs: '',
                    hr: '',
                    cp: '',
                },
                description: {
                    en: '',
                    bs: '',
                    hr: '',
                    cp: '',
                },
                errors: {}
            }
        },
        computed: {
            languages () {
                return model.getLanguages()
            }
        },
        methods: {
            isActiveTab(id) {
                return this.active === id
            },
            langData() {
                let data = {};
                data[this.inputKey] = this.input;
                this.$emit('langData', data);
            }
        },
        created () {
            this.inputValue ? this.input = this.inputValue : console.log('nema');
        },
        watch: {
            inputValue () {
                this.inputValue ? this.input = this.inputValue : this.input = {
                    en: '',
                    bs: '',
                    hr: '',
                    cp: '',
                }
                console.log(this.input)
            }
        }
    }
</script>


<style scoped>
    .el-form-item.is-error .el-input__inner {
        border-color: #f56c6c;
    }

    .el-form-item ul {
        padding: 0;
    }
    
    .el-form-item ul li {
        list-style: none;
        display: inline-block;
        padding-right: 20px;
    }

    .el-form-item ul li a {
        font-weight: bold;
        cursor: pointer;
    }

    .el-form-item ul li.is-active {
        color: #409EFF;
    }

    .el-input {
        margin: 0;
    }
    .lang-tabs {
        margin-top: 10px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/LangTabs/LangTabs.vue